package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AccountBox
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Face
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.ShoppingCart
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.data.RemDossier
import br.com.htms.inspeccaocampo.data.RemVisao
import br.com.htms.inspeccaocampo.data.ativos.AtivosApi
import br.com.htms.inspeccaocampo.data.colaboradores.ColaboradoresApi
import br.com.htms.inspeccaocampo.data.efetivo.EfetivoApi
import br.com.htms.inspeccaocampo.data.ocorrencias.OcorrenciasApi
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.ui.dashboards.CarregadorDash
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardAtivos
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardColaboradores
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardDocumentosCarregando
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardEfetivo
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardEstoque
import br.com.htms.inspeccaocampo.ui.dashboards.carregarEstoqueDash
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardInspecoes
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardOcorrencias
import br.com.htms.inspeccaocampo.ui.kit.PainelDashboard
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.SemDadosDash
import br.com.htms.inspeccaocampo.ui.theme.PortalCores

private enum class ModDash(val rotulo: String, val icone: ImageVector) {
    INSPECOES("Inspeções e checklists", Icons.Filled.List),
    OCORRENCIAS("Gestão de Ocorrências", Icons.Filled.Warning),
    REM("REM — Segurança", Icons.Filled.DateRange),
    COLABORADORES("Colaboradores", Icons.Filled.Person),
    EFETIVO("Efetivo", Icons.Filled.Face),
    ATIVOS("Ativos", Icons.Filled.Build),
    ESTOQUE("Estoque", Icons.Filled.ShoppingCart),
    DOCUMENTOS("Emissão de documentos", Icons.Filled.AccountBox)
}

@Composable
fun SharedDashboardsScreen(controller: AppController) {
    val authUser by controller.authUser.collectAsState()
    val config by controller.appConfig.collectAsState()
    val u = authUser
    val liberados = ModDash.entries.filter { m ->
        when (m) {
            ModDash.INSPECOES -> u != null
            ModDash.OCORRENCIAS -> u?.podeAcessarOcorrencias == true
            ModDash.REM -> u?.canAccessForm(FormTipo.REM_SEGURANCA_OBRAS, config) == true
            ModDash.COLABORADORES -> u?.podeAcessarColaboradores == true
            ModDash.EFETIVO -> u?.podeAcessarEfetivo == true
            ModDash.ATIVOS -> u?.podeAcessarAtivos(config) == true
            ModDash.ESTOQUE -> u?.podeAcessarEstoque == true
            ModDash.DOCUMENTOS -> u?.podeAcessarColaboradores == true || u?.podeEmitirDocumentos(config) == true
        }
    }
    var mod by remember { mutableStateOf(liberados.firstOrNull() ?: ModDash.INSPECOES) }

    PortalModulo(
        titulo = "Dashboards",
        itens = liberados.map { PortalMenuItem(it.name, it.rotulo, it.icone) },
        selecionado = mod.name,
        onSelect = { mod = ModDash.valueOf(it) }
    ) { _ ->
        when (mod) {
            ModDash.INSPECOES -> DashboardInspecoes(controller)
            ModDash.OCORRENCIAS -> CarregadorDash("Gestão de Ocorrências", mod, { OcorrenciasApi.dados() }) { d, r, c -> DashboardOcorrencias(d, c, r) }
            ModDash.REM -> DashRemCentral(controller)
            ModDash.COLABORADORES -> CarregadorDash("Colaboradores", mod, { ColaboradoresApi.dados() }) { d, r, c -> DashboardColaboradores(d, c, r) }
            ModDash.EFETIVO -> CarregadorDash("Efetivo", mod, { EfetivoApi.dados() }) { d, r, c -> DashboardEfetivo(d, c, r) }
            ModDash.ATIVOS -> CarregadorDash("Ativos", mod, { AtivosApi.dados().mapCatching { it ?: error("Sem dados do Controle de Ativos.") } }) { d, r, c ->
                DashboardAtivos(d, c, r)
            }
            ModDash.ESTOQUE -> CarregadorDash("Estoque", mod, { carregarEstoqueDash() }) { d, r, c -> DashboardEstoque(d, c, r) }
            ModDash.DOCUMENTOS -> DashboardDocumentosCarregando(mod)
        }
    }
}

@Composable
private fun DashRemCentral(controller: AppController) {
    val admin = controller.isAdmin
    CarregadorDash("REM — Segurança do Trabalho", "rem", { AuthApi.listRemDossiers(all = admin) }) { lista, recarregar, carregandoLista ->
        val ordenados = lista.sortedWith(compareByDescending<RemDossier> { it.ano }.thenBy { it.obra })
        var sel by remember(lista) { mutableStateOf(ordenados.firstOrNull()?.id.orEmpty()) }
        var visao by remember { mutableStateOf(RemVisao.CONSOLIDADO) }
        var dossie by remember { mutableStateOf<RemDossier?>(null) }
        var carregando by remember { mutableStateOf(false) }
        var erro by remember { mutableStateOf<String?>(null) }
        LaunchedEffect(sel) {
            if (sel.isBlank()) return@LaunchedEffect
            carregando = true
            AuthApi.getRemDossier(sel)
                .onSuccess { dossie = it; erro = null }
                .onFailure { erro = it.message ?: "Falha ao abrir o dossiê." }
            carregando = false
        }
        val duplicados = ordenados.groupBy { it.obra to it.ano }.filterValues { it.size > 1 }.keys
        val d = dossie?.takeIf { it.id == sel }
        PainelDashboard(
            titulo = "Dashboard — REM",
            subtitulo = d?.let { "${it.obra} · ${it.ano} · ${visao.rotulo}" } ?: "Escolha o dossiê (obra e ano)",
            carregando = carregando || carregandoLista,
            erro = erro,
            onAtualizar = recarregar,
            filtros = {
                Box(Modifier.widthIn(min = 260.dp, max = 520.dp)) {
                    Seletor(
                        "Dossiê (obra · ano)",
                        ordenados.map {
                            it.id to "${it.obra} · ${it.ano}" + if ((it.obra to it.ano) in duplicados) " (${it.username.orEmpty()})" else ""
                        },
                        sel, { sel = it }
                    )
                }
                SeletorVisao(visao) { visao = it }
            }
        ) { largo, grande ->
            when {
                ordenados.isEmpty() -> SemDadosDash("Sem dossiês", "Nenhum dossiê REM criado. Abra o formulário REM para lançar os meses.")
                d == null -> CircularProgressIndicator(color = PortalCores.Navy)
                else -> DashboardRem(d.months, visao, largo, grande)
            }
        }
    }
}
